export enum ScreenParallaxAnimationEnum {
  WITHOUT = "WITHOUT",
  FROM_TOP = "FROM_TOP",
  FROM_BOTTOM = "FROM_BOTTOM",
  FROM_LEFT_TO_RIGHT = "FROM_LEFT_TO_RIGHT",
  FROM_RIGHT_TO_LEFT = "FROM_RIGHT_TO_LEFT",
}
